import { Injectable } from "@angular/core";
import { CargoAuthResponse } from "@app/modules/auth/entities";
import { PERMISSION } from "@app/modules/roles/constants";
import { localStorageKey } from "@core/constants";
import { select } from "@ngrx/store";
import { StorageMap } from "@ngx-pwa/local-storage";
import { map, take } from "rxjs/operators";
@Injectable({
  providedIn: "root",
})
export class PermissionService {
  constructor(private storage: StorageMap) {}

  permissionGroup$ = this.storage.watch(localStorageKey).pipe(select((s: CargoAuthResponse) => s?.permissionGroup));

  public hasPermission(requestingPermission: PERMISSION) {
    return this.permissionGroup$.pipe(
      take(1),
      map(({ permissions }) => permissions.includes(requestingPermission))
    );
  }

  public hasAnyPermission(requestingPermissions: PERMISSION[]) {
    return this.permissionGroup$.pipe(
      take(1),
      map(({ permissions }) => permissions.some(p => requestingPermissions.includes(p)))
    );
  }

  public hasAllPermissions(requestingPermissions: PERMISSION[]) {
    return this.permissionGroup$.pipe(
      take(1),
      map(({ permissions }) => !permissions.some(p => !requestingPermissions.includes(p)))
    );
  }
}
